const menus = [
  {
    id: 1,
    tomenu: "#about",
    namemenu: "About",
  },
  {
    id: 2,
    tomenu: "#languages",
    namemenu: "Languages",
  },
 
  {
    id: 3,
    tomenu: "#portfolio",
    namemenu: "Portfolio",
  },
  {
    id: 4,
    tomenu: "#education",
    namemenu: "Education",
  },
    
  {
    id: 5,
    tomenu: "#contact",
    namemenu: "Contact",
  },
];



export default menus;